import Button from '@doordash/component-button'
import { InlineChildren } from '@doordash/design-language'
import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import { CountryCode } from '@doordash/lib-i18n'
import * as React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as events from '../../../events'
import { DX_CRO_LP_GRADUATION_Q3_2020 } from '../../../experimentConstants'
import * as DA from '../../../typeModules/events'
import Hamburger, { getHamburgerList } from '../../atoms/hamburger-menu'
import { SimpleStyleType } from '../../templates/simple/constants'
import t from './strings'
import {
  DesktopLogo,
  HeaderStyle,
  InsetContainer,
  LoginButton,
  MobileLogo,
  DoorDashLogo,
  DoorDashLogoContainer,
} from './styles'
import DesktopHeaderActions from './DesktopHeader'
import { COUNTRY_SHORTCODES } from '../../../constants'

const { logIn } = t

interface IHeaderButton {
  href: string
  title: string
}

type HeaderProps = {
  isDark?: boolean
  isMobile?: boolean
  headerButton?: IHeaderButton
  hideWhenMobile?: boolean
  isDesktopWidth?: boolean
  type: SimpleStyleType
  showGetStarted?: boolean
  country?: CountryCode
  scrollHeight?: number
}

type ReduxProps = {
  toggleAlreadyStartedSigningUpModal?: () => void
  trackLandingPageHeader?: (data: DA.LandingPageHeader) => void
}

/**
 * TODO: add scroll listener to make header sticky
 *
 * @deprecated Use organisms/navbar/Navbar for a simple navbar instead
 */
export const Header: React.FC<HeaderProps & ReduxProps> = ({
  isDark = false,
  headerButton,
  hideWhenMobile = false,
  toggleAlreadyStartedSigningUpModal,
  trackLandingPageHeader,
  type,
  children,
  showGetStarted,
  scrollHeight,
  country,
}) => (
  <HeaderStyle
    isDark={isDark}
    hideWhenMobile={hideWhenMobile}
    type={type}
    experimentQ3={isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q3_2020)}
    isShadow={
      (isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q3_2020) &&
        country === COUNTRY_SHORTCODES.US) ||
      country === COUNTRY_SHORTCODES.AU
    }
    country={country}
    isScrolled={
      isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q3_2020) && scrollHeight > 0
    }
    isTransparent={
      isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q3_2020) &&
      country === COUNTRY_SHORTCODES.CA
    }
  >
    {children || (
      <InsetContainer>
        <MobileLogo
          experimentQ3={isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q3_2020)}
        >
          <InlineChildren
            alignItems={InlineChildren.Alignment.Center}
            justifyContent={InlineChildren.Justification.SpaceBetween}
          >
            {type === SimpleStyleType.Landing && (
              <Hamburger itemList={getHamburgerList()} />
            )}
            <DoorDashLogoContainer>
              <DoorDashLogo showLogoText={false} />
            </DoorDashLogoContainer>
            {type === SimpleStyleType.Landing && (
              <LoginButton
                onClick={() => {
                  toggleAlreadyStartedSigningUpModal()
                  trackLandingPageHeader({
                    action: DA.EventActions.Clicked,
                    name: DA.HeaderNames.LogInButton,
                  })
                }}
              >
                {logIn()}
              </LoginButton>
            )}
          </InlineChildren>
        </MobileLogo>

        <DesktopLogo
          experimentQ3={isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q3_2020)}
        >
          <InlineChildren
            alignItems={InlineChildren.Alignment.Center}
            justifyContent={InlineChildren.Justification.SpaceBetween}
          >
            <DoorDashLogo showLogoText={true} />
            {headerButton && (
              <Button
                type={Button.Types.PrimaryPill}
                tag="a"
                href={headerButton.href}
                isInline
              >
                {headerButton.title}
              </Button>
            )}
            {isFeatureFlagEnabled(DX_CRO_LP_GRADUATION_Q3_2020) &&
              !(
                country === COUNTRY_SHORTCODES.JP ||
                country === COUNTRY_SHORTCODES.DE
              ) && (
                <DesktopHeaderActions
                  toggleAlreadyStartedSigningUpModal={
                    toggleAlreadyStartedSigningUpModal
                  }
                  showGetStarted={showGetStarted}
                />
              )}
          </InlineChildren>
        </DesktopLogo>
      </InsetContainer>
    )}
  </HeaderStyle>
)

Header.defaultProps = {
  isDark: true,
  hideWhenMobile: false,
}

const mapDispatchToProps = {
  toggleAlreadyStartedSigningUpModal:
    actions.toggleAlreadyStartedSigningUpModal,
  trackLandingPageHeader: events.trackLandingPageHeader,
}

export default connect(null, mapDispatchToProps)(Header)
